import { createWebHashHistory, createRouter, type RouteRecordRaw } from 'vue-router'

import ExampleGallery from '../components/ExampleGallery.vue'
import GS3DSpatialCapsuleWalkView from '../components/GS3DSpatialCapsuleWalkView.vue'
import CameraAnimationView from '../components/CameraAnimationView.vue'
import GS3DEffectAnimationView from '../components/GS3DEffectAnimationView.vue'
import GS3DView from '../components/GS3DView.vue'
import GS3DEffectsView from '../components/GS3DEffectsView.vue'
import GS3DSpatialQueryView from '../components/GS3DSpatialQueryView.vue'
import LoadCloud from '../components/LoadCloud.vue'
import MeshExampleView from '../components/MeshExampleView.vue'
import PotreeView from '../components/PotreeView.vue'
import SemanticPointCloudView from '../components/SemanticPointCloudView.vue'
import ThreeScene from '../components/ThreeScene.vue'
import CADView from '../components/CADView.vue'
import CadDualViewportView from '../components/CadDualViewportView.vue'
import MultiViewportView from '../components/MultiViewportView.vue'

export const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../components/HomeView.vue'),
  },
  {
    path: '/examples/:slug?',
    name: 'examples-hub',
    component: ExampleGallery,
  },
  {
    path: '/changelog/:version?',
    name: 'changelog',
    component: () => import('../components/ChangelogView.vue'),
  },
  {
    path: '/standalone/potree',
    name: 'standalone-potree',
    component: PotreeView,
  },
  {
    path: '/standalone/semantic-point-cloud',
    name: 'standalone-semantic-point-cloud',
    component: SemanticPointCloudView,
  },
  {
    path: '/standalone/gs3d',
    name: 'standalone-gs3d',
    component: GS3DView,
  },
  {
    path: '/standalone/gs3d-effects',
    name: 'standalone-gs3d-effects',
    component: GS3DEffectsView,
  },
  {
    path: '/standalone/camera-animation',
    name: 'standalone-camera-animation',
    component: CameraAnimationView,
  },
  {
    path: '/standalone/gs3d-effect-animation',
    name: 'standalone-gs3d-effect-animation',
    component: GS3DEffectAnimationView,
  },
  {
    path: '/standalone/gs3d-spatial-query',
    name: 'standalone-gs3d-spatial-query',
    component: GS3DSpatialQueryView,
  },
  {
    path: '/standalone/gs3d-spatial-capsule-walk',
    name: 'standalone-gs3d-spatial-capsule-walk',
    component: GS3DSpatialCapsuleWalkView,
  },
  {
    path: '/standalone/load-cloud',
    name: 'standalone-load-cloud',
    component: LoadCloud,
  },
  {
    path: '/standalone/tiles-mesh',
    name: 'standalone-tiles-mesh',
    component: () => import('../components/TilesMeshExampleView.vue'),
  },
  {
    path: '/standalone/tiles-webgpu-validation',
    name: 'standalone-tiles-webgpu-validation',
    component: () => import('../components/TilesMeshExampleView.vue'),
    props: { webgpuValidation: true },
  },
  {
    path: '/standalone/mesh-damaged-helmet',
    name: 'standalone-mesh-damaged-helmet',
    component: MeshExampleView,
    props: { modelKey: 'damagedHelmet' },
  },
  {
    path: '/standalone/mesh-horse',
    name: 'standalone-mesh-horse',
    component: MeshExampleView,
    props: { modelKey: 'horse' },
  },
  {
    path: '/standalone/mesh-ktx2',
    name: 'standalone-mesh-ktx2',
    component: () => import('../components/MeshExampleView.vue'),
    props: { modelKey: 'ktx2Mixed' },
  },
  {
    path: '/standalone/three-lines',
    name: 'standalone-three-lines',
    component: ThreeScene,
  },
  {
    path: '/standalone/cad',
    name: 'standalone-cad',
    component: CADView,
  },
  {
    path: '/standalone/cad-multi-viewport',
    name: 'standalone-cad-multi-viewport',
    component: CadDualViewportView,
  },
  {
    path: '/standalone/multi-viewport',
    name: 'standalone-multi-viewport',
    component: MultiViewportView,
  },
  {
    path: '/standalone/low-memory-gltf-benchmark',
    name: 'low-memory-gltf-benchmark',
    component: () => import('../components/LowMemoryGltfBenchmarkView.vue'),
  },
  {
    path: '/standalone/webgpu-initialization-spike',
    name: 'webgpu-initialization-spike',
    component: () => import('../components/WebGPUInitializationSpikeView.vue'),
  },
  {
    path: '/standalone/webgpu-gsplat-cpu-baseline',
    name: 'webgpu-gsplat-cpu-baseline',
    component: () => import('../components/WebGPUGSplatCpuBaselineView.vue'),
  },
  {
    path: '/standalone/webgpu-gsplat-gpu-baseline',
    name: 'webgpu-gsplat-gpu-baseline',
    component: () => import('../components/WebGPUGSplatCpuBaselineView.vue'),
  },
  {
    path: '/standalone/webgpu-gsplat-radix-validation',
    name: 'webgpu-gsplat-radix-validation',
    component: () => import('../components/WebGPUGSplatRadixValidationView.vue'),
  },
  {
    path: '/potree',
    redirect: { name: 'standalone-potree' },
  },
  {
    path: '/semantic-point-cloud',
    redirect: { name: 'standalone-semantic-point-cloud' },
  },
  {
    path: '/gs3d',
    redirect: { name: 'standalone-gs3d' },
  },
  {
    path: '/gs3d-effects',
    redirect: { name: 'standalone-gs3d-effects' },
  },
  {
    path: '/gs3d-camera-animation',
    redirect: { name: 'standalone-camera-animation' },
  },
  {
    path: '/gs3d-effect-animation',
    redirect: { name: 'standalone-gs3d-effect-animation' },
  },
  {
    path: '/gs3d-spatial-query',
    redirect: { name: 'standalone-gs3d-spatial-query' },
  },
  {
    path: '/spatial-capsule-walk',
    redirect: { name: 'standalone-gs3d-spatial-capsule-walk' },
  },
  {
    path: '/load',
    redirect: { name: 'standalone-load-cloud' },
  },
  {
    path: '/canvas',
    redirect: { name: 'standalone-three-lines' },
  },
  {
    path: '/multi-viewport',
    redirect: { name: 'standalone-multi-viewport' },
  },
  {
    path: '/cad-multi-viewport',
    redirect: { name: 'standalone-cad-multi-viewport' },
  },
] satisfies RouteRecordRaw[]

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
})
